import { CardInfo } from "./card-info.model";

export class CardInfoTranslation  {
   /*
   *
   */
    constructor(
      public id?:  number,
      public locale?: string,
      public title?: string,
      public cardInfo?: CardInfo  
    ){}
    
}